import { PropsWithChildren, useState } from 'react'
import { useFocusWithin } from '@react-aria/interactions'
import cx from 'classnames'
import Styles from './AddReviewers.module.scss'

export const Field = ({
  children,
  focusable = true,
  className,
}: PropsWithChildren<{ focusable?: boolean; className?: string }>) => {
  const [isFocusWithin, setFocusWithin] = useState(false)
  const { focusWithinProps } = useFocusWithin({
    isDisabled: !focusable,
    onFocusWithinChange: (isFocusWithin) => setFocusWithin(isFocusWithin),
  })
  return (
    <div className={cx(className, Styles.field, { [Styles.focused]: isFocusWithin })} {...focusWithinProps}>
      {children}
    </div>
  )
}
